import { render, staticRenderFns } from "./ProjectGridCompleted.vue?vue&type=template&id=09537256&"
import script from "./ProjectGridCompleted.vue?vue&type=script&lang=js&"
export * from "./ProjectGridCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGridCompleted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports